export default __webpack_public_path__ + "static/media/storeBanner.3a491c9e.png";